import React from 'react';
export function Footer() {
  return <footer className="bg-leather-dark text-cream/70 py-12 px-4 sm:px-6 lg:px-8" data-id="element-74">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-75">
        <div className="text-center md:text-left" data-id="element-76">
          <p className="font-heading text-2xl font-bold text-gold mb-2" data-id="element-77">
            Biblioteca de Patrones
          </p>
          <p className="text-sm" data-id="element-78">
            © {new Date().getFullYear()} Todos los derechos reservados.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-79">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-80">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-81">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-82">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}